import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { Article } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { startupsUrl } from '@src/lib/startups-url';
import { ArticleJsonLd, ArticleJsonLdProps, JsonLdScript } from 'next-seo';
import React from 'react';
export const ArticleSEO = props => {
  const $ = _c(34);
  const article = props.article;
  let pathPrefix = "articles";
  if (article.type === "FounderStory") {
    pathPrefix = "founder-interviews";
  } else {
    if (article.type === "Lexicon") {
      pathPrefix = "lexicon";
    }
  }
  let imageUrl;
  let seoProps;
  if ($[0] !== article.authors[0]?.avatar?.url || $[1] !== article.authors[0]?.firstName || $[2] !== article.authors[0]?.lastName || $[3] !== article.featuredImage?.url || $[4] !== article.seoDescription || $[5] !== article.seoImage?.url || $[6] !== article.seoTitle || $[7] !== article.slug || $[8] !== article.subjectNames || $[9] !== article.teaser || $[10] !== article.title || $[11] !== article.type || $[12] !== pathPrefix) {
    seoProps = {};
    seoProps.title = article.seoTitle || article.title;
    if (article.type === "FounderStory" && article.subjectNames?.length > 0) {
      seoProps.title = seoProps.title.indexOf("Interview") >= 0 ? seoProps.title : `${seoProps.title} | Interview with ${article.subjectNames.join(", ")}`;
    }
    seoProps.description = article.seoDescription || article.teaser || seoProps.description;
    seoProps.url = startupsUrl(`/${pathPrefix}/${article.slug}`);
    imageUrl = article.seoImage?.url || article.featuredImage?.url || startupsUrl("/api/og-image", {
      badge: "Article",
      title: seoProps.title,
      tagline: seoProps.description,
      author: [article.authors[0]?.firstName, article.authors[0]?.lastName].filter(Boolean).join(" "),
      avatar: article.authors[0]?.avatar?.url
    });
    if (imageUrl) {
      seoProps.imageUrl = imageUrl;
    }
    $[0] = article.authors[0]?.avatar?.url;
    $[1] = article.authors[0]?.firstName;
    $[2] = article.authors[0]?.lastName;
    $[3] = article.featuredImage?.url;
    $[4] = article.seoDescription;
    $[5] = article.seoImage?.url;
    $[6] = article.seoTitle;
    $[7] = article.slug;
    $[8] = article.subjectNames;
    $[9] = article.teaser;
    $[10] = article.title;
    $[11] = article.type;
    $[12] = pathPrefix;
    $[13] = imageUrl;
    $[14] = seoProps;
  } else {
    imageUrl = $[13];
    seoProps = $[14];
  }
  let t0;
  if ($[15] !== article.authors) {
    t0 = article.authors.map(_temp).join(", ");
    $[15] = article.authors;
    $[16] = t0;
  } else {
    t0 = $[16];
  }
  const t1 = imageUrl || "";
  let t2;
  if ($[17] !== article.publishedAt || $[18] !== article.updatedAt || $[19] !== seoProps.description || $[20] !== seoProps.title || $[21] !== seoProps.url || $[22] !== t0 || $[23] !== t1) {
    t2 = {
      type: "Article",
      author: t0,
      headline: seoProps.title,
      description: seoProps.description,
      image: t1,
      datePublished: article.publishedAt,
      dateModified: article.updatedAt,
      url: seoProps.url,
      isAccessibleForFree: true
    };
    $[17] = article.publishedAt;
    $[18] = article.updatedAt;
    $[19] = seoProps.description;
    $[20] = seoProps.title;
    $[21] = seoProps.url;
    $[22] = t0;
    $[23] = t1;
    $[24] = t2;
  } else {
    t2 = $[24];
  }
  const articleDataProps = t2;
  let t3;
  if ($[25] !== seoProps) {
    t3 = <SEOMetadata {...seoProps} />;
    $[25] = seoProps;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  let t4;
  if ($[27] !== article.seoStructuredData || $[28] !== article.slug || $[29] !== articleDataProps) {
    t4 = article.seoStructuredData ? <JsonLdScript data={article.seoStructuredData} scriptKey={article.slug} /> : <ArticleJsonLd {...articleDataProps} />;
    $[27] = article.seoStructuredData;
    $[28] = article.slug;
    $[29] = articleDataProps;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== t3 || $[32] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  return t5;
};
ArticleSEO.fragments = {
  Article: () => gql`
    fragment _ on Article {
      id
      title
      slug
      teaser
      authors {
        id
        firstName
        lastName
      }
      publishedAt
      subjectNames
      subjectLogos {
        id
        url
        altText
      }
      featuredImage {
        id
        url
        altText
      }
      type
      seoTitle
      seoDescription
      seoKeywords
      seoStructuredData
      seoImage {
        id
        url
        altText
      }
      updatedAt
      __typename
    }
  `
};
function _temp(author) {
  return [author.firstName, author.lastName].filter(Boolean);
}